<template>
  <div class="row step-details no-gutters">
    <div class="step-inputs col-lg-8">

      <div class="page-intro">
        <h3>Tell Us About You</h3>
      </div>

      <vue-subscriber-details 
        :subscriber="subscriber"
        @updated:subscriber="updateSubscriber"
        ></vue-subscriber-details>    

    </div>

    <div class="col-lg-4 deal-info-content">
      <vue-deal-info />
    </div>

  </div>
</template>


<script>
import store from "@/store";
import VueSubscriberDetails from "@/components/elements/vue-subscriber-details";
import VueDealInfo from "@/components/elements/vue-deal-info";
import SubscriberModel from "@/models/subscriber.model";

import {   
  CART_UPDATE_SUBSCRIBER
} from "@/store/actions.type";

export default {
  name: "subscriber-details",
  components: {
    "vue-deal-info": VueDealInfo,
    "vue-subscriber-details": VueSubscriberDetails
  },
  props: ["builder"],
  data: function() {
    return {
      subscriber: new SubscriberModel(store.state.cart.current_sim.subscriber),
      showLogin: false
    };
  },
  methods: {
    updateSubscriber(update) {
      self.subscriber = update;
      store.dispatch(CART_UPDATE_SUBSCRIBER, update);   
    },
    isEmpty(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    }
  },
  mounted() {
    var self = this;
    self.$scrollTo("body");
  }
};
</script>